import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUserAdded: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="user-added, people, person, member, checked"><path d="M12 20.25H4.75V19.5C4.75 15.4959 7.99594 12.25 12 12.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="7.75" r="4.5" stroke="currentColor" strokeWidth="1.5"/><path d="M14.75 18.5543L16.9318 20.25L20.75 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconUserAdded;
